const Box = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="container">
      <path
        id="Icon"
        d="M15.375 5.45874L8.99998 9.00041M8.99998 9.00041L2.62498 5.45874M8.99998 9.00041L9 16.1254M15.75 12.0443V5.95651C15.75 5.69953 15.75 5.57104 15.7121 5.45644C15.6786 5.35506 15.6239 5.262 15.5515 5.18348C15.4697 5.09473 15.3574 5.03233 15.1328 4.90752L9.58277 1.82419C9.37007 1.70602 9.26372 1.64694 9.15109 1.62377C9.05141 1.60327 8.9486 1.60327 8.84891 1.62377C8.73628 1.64694 8.62993 1.70602 8.41723 1.82419L2.86723 4.90753C2.64259 5.03233 2.53026 5.09473 2.44847 5.18348C2.37612 5.262 2.32136 5.35506 2.28786 5.45644C2.25 5.57104 2.25 5.69953 2.25 5.95651V12.0443C2.25 12.3013 2.25 12.4298 2.28786 12.5444C2.32136 12.6458 2.37612 12.7389 2.44847 12.8174C2.53026 12.9061 2.64259 12.9685 2.86723 13.0933L8.41723 16.1767C8.62993 16.2948 8.73628 16.3539 8.84891 16.3771C8.9486 16.3976 9.05141 16.3976 9.15109 16.3771C9.26372 16.3539 9.37007 16.2948 9.58277 16.1767L15.1328 13.0933C15.3574 12.9685 15.4697 12.9061 15.5515 12.8174C15.6239 12.7389 15.6786 12.6458 15.7121 12.5444C15.75 12.4298 15.75 12.3013 15.75 12.0443Z"
        stroke="#6D28D9"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);

export default Box;
